import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiArrowRight } from 'react-icons/fi';
import { SiTiktok } from 'react-icons/si';
import '../styles/Footer.css';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const DEFAULT_FOOTER_CONFIG = {
  column1: {
    title: 'Customer Service',
    links: [
      { label: 'Contact us', pageId: 'contact' },
      { label: 'Size guide', pageId: 'size-guide' },
      { label: 'Delivery', pageId: 'delivery' },
      { label: 'Return & exchanges', pageId: 'returns-and-exchange' },
      { label: 'Care of products', pageId: 'care-of-products' }
    ]
  },
  column2: {
    title: 'Company Information',
    links: [
      { label: 'About', pageId: 'about' },
      { label: 'Terms & Conditions', pageId: 'terms' },
      { label: 'Privacy Policy', pageId: 'privacy' }
    ]
  }
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeMessage, setSubscribeMessage] = useState('');
  const [footerConfig, setFooterConfig] = useState(DEFAULT_FOOTER_CONFIG);

  // Fetch footer config from API
  useEffect(() => {
    const fetchFooterConfig = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/footer-config`);
        if (response.ok) {
          const data = await response.json();
          setFooterConfig({
            column1: data.column1,
            column2: data.column2
          });
        }
      } catch (error) {
        console.error('Error fetching footer config:', error);
        // Keep current config if fetch fails
      }
    };

    fetchFooterConfig();
  }, []);


  const getLinkPath = (pageId) => {
    // Use the generic /page/:pageId route for all pages
    return `/page/${pageId}`;
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      // TODO: Send email to backend newsletter service
      setSubscribeMessage('Thank you for subscribing!');
      setEmail('');
      setTimeout(() => setSubscribeMessage(''), 3000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1 */}
        {footerConfig && footerConfig.column1 && (
          <div className="footer-section">
            <h4>{footerConfig.column1.title}</h4>
            <ul>
              {footerConfig.column1.links.map((link, idx) => (
                <li key={idx}>
                  <Link to={getLinkPath(link.pageId)}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Column 2 */}
        {footerConfig && footerConfig.column2 && (
          <div className="footer-section">
            <h4>{footerConfig.column2.title}</h4>
            <ul>
              {footerConfig.column2.links.map((link, idx) => (
                <li key={idx}>
                  <Link to={getLinkPath(link.pageId)}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Newsletter Column */}
        <div className="footer-section newsletter-section">
          <h4>Sign to our newsletter</h4>
          <div className="newsletter-wrapper">
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="newsletter-btn">
                <FiArrowRight />
              </button>
            </form>
            <div className="social-icons">
              <a href="https://instagram.com/huhuashoes" title="Instagram" rel="noopener noreferrer" target="_blank"><FiInstagram /></a>
              <a href="https://www.facebook.com/profile.php?id=61559829345563" title="Facebook" rel="noopener noreferrer" target="_blank"><FiFacebook /></a>
              <a href="https://tiktok.com/@huhuashoes" title="TikTok" rel="noopener noreferrer" target="_blank"><SiTiktok /></a>
            </div>
          </div>
          {subscribeMessage && <p className="subscribe-message">{subscribeMessage}</p>}
        </div>
      </div>

      <div className="footer-branding">
        <p>&copy; 2024 HuHua Shoes. All rights reserved.</p>
      </div>
    </footer>
  );
}
